import lozad from 'lozad';

import { rest_request } from './_partials/_rest.js';
import { create_scroll_spy } from './_partials/_scroll-spy.js';

(function () {
	const button_el = document.getElementById(`js-mobile-toc`);
	if (!button_el) {
		return;
	}

	function on_click(e) {
		e.currentTarget.classList.toggle(`open`);
	}

	button_el.addEventListener(`click`, on_click);
})();

(function () {
	const list_els = document.querySelectorAll(`.widget_sh_table_of_contents`);

	for (const list_el of list_els) {
		const scroller_el = list_el.querySelector(`nav`);

		create_scroll_spy(list_el, {
			active_class: `current`,
			sticky: `.site-header`,
			on_change(active_el) {
				if (!active_el || !scroller_el) {
					return;
				}

				scroller_el.scrollTop = active_el.offsetTop - scroller_el.offsetTop;
			},
		});
	}
})();

(function () {
	const observer = lozad(`.entry-editors .carousel`, {
		load(el) {
			const carousel_cell_els = el.getElementsByClassName(`carousel-cell`);
			if (carousel_cell_els.length <= 1) {
				return;
			}

			import(`flickity`).then(({ default: Flickity }) => {
				new Flickity(el, {
					wrapAround: true,
					// autoPlay: 5000,
					cellAlign: `left`,
					adaptiveHeight: true,
					pageDots: true,
					prevNextButtons: true,
				});
			});
		},
	});

	observer.observe();
})();

(function () {
	const all_button_els = document.querySelectorAll(`.related-posts nav .btn`);
	if (all_button_els.length === 0) {
		return;
	}

	function on_click(e) {
		const button_el = e.currentTarget;

		if (button_el.classList.contains(`active`)) {
			return;
		}

		const container_el = button_el.closest(`.related-posts`);
		if (!container_el) {
			return;
		}

		const button_els = container_el.querySelectorAll(`nav .btn`);
		const tab_els = container_el.querySelectorAll(`.tab`);

		const idx = button_el.dataset.idx;

		for (let i = 0; i < button_els.length; i++) {
			if (button_els[i].dataset.idx === idx) {
				button_els[i].classList.add(`active`);
			} else {
				button_els[i].classList.remove(`active`);
			}
		}

		for (let i = 0; i < tab_els.length; i++) {
			if (tab_els[i].dataset.idx === idx) {
				tab_els[i].classList.add(`active`);
			} else {
				tab_els[i].classList.remove(`active`);
			}
		}
	}

	for (let i = 0; i < all_button_els.length; i++) {
		all_button_els[i].addEventListener(`click`, on_click);
	}
})();

(function () {
	const button_els = document.querySelectorAll(`.related-posts .show-more .btn`);
	if (button_els.length === 0) {
		return;
	}

	function on_click(e) {
		const button_el = e.currentTarget;

		button_el.closest(`.tab`).classList.add(`show-all`);
	}

	for (let i = 0; i < button_els.length; i++) {
		button_els[i].addEventListener(`click`, on_click);
	}
})();

(function () {
	let page = 1;

	const container_el = document.getElementById(`js-related`);
	if (!container_el) {
		return;
	}

	const post_id = parseInt(container_el.dataset.post_id, 10);

	const content_el = container_el.querySelector(`.inner`);
	if (!content_el) {
		return;
	}

	const footer_el = container_el.querySelector(`footer`);
	if (!footer_el) {
		return;
	}

	const more_button_el = footer_el.querySelector(`.btn`);
	if (!more_button_el) {
		return;
	}

	function fetch() {
		more_button_el.disabled = true;

		rest_request(`related/${post_id}?page=${page}`, {
			include_credentials: true,
		})
			.then((response) => {
				more_button_el.disabled = false;

				const parser = new window.DOMParser(),
					doc = parser.parseFromString(response, `text/html`),
					entries = doc.querySelectorAll(`.snippet`);

				for (let i = 0; i < entries.length; i++) {
					content_el.appendChild(entries[i].cloneNode(true));
				}

				if (entries.length < 6) {
					footer_el.parentNode.removeChild(footer_el);
				} else {
					const category_url = more_button_el.dataset.category_url;

					if (category_url && category_url.length > 0) {
						more_button_el.parentNode.removeChild(more_button_el);

						const link_el = document.createElement(`a`);
						link_el.href = category_url;
						link_el.textContent = more_button_el.textContent;
						link_el.className = more_button_el.className;

						footer_el.appendChild(link_el);
					}
				}
			})
			.catch(() => {
				footer_el.parentNode.removeChild(footer_el);
			});
	}

	function load_more() {
		page++;
		fetch();
	}

	more_button_el.addEventListener(`click`, load_more);
})();
